export default __webpack_public_path__ + "static/media/johor2019A.409bff95.jpg";